module.exports = __webpack_public_path__ + "img/polpette-vegetali.acc10e20.png";